let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fxgls")).then(() => parcelRequire('kHcBe'));